/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2022, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import _ from 'lodash';

import { ApiStatus } from '../../../../ts/';
import { getSingleUnrecognizedGroup } from '../actions';

export const singleRecognizedGroupReducers = {
  [getSingleUnrecognizedGroup.pending.toString()]: state => {
    state.singleUnrecognizedGroup.loading = ApiStatus.LOADING;
    state.singleUnrecognizedGroup.total = 0;
    state.singleUnrecognizedGroup.examples = [];
    state.singleUnrecognizedGroup.groups = [];
  },
  [getSingleUnrecognizedGroup.fulfilled.toString()]: (state, action) => {
    const { actions, intent, count, examples, groups } = action.payload;
    const { examplesWithTitles, groupWithTitles } =
      formateExamplesWithActionTitle(examples, groups, actions);
    state.singleUnrecognizedGroup = {
      ...state.singleUnrecognizedGroup,
      action: intent,
      total: count,
      examples: examplesWithTitles,
      groups: groupWithTitles,
      loading: ApiStatus.SUCCEEDED
    };
  },
  [getSingleUnrecognizedGroup.rejected.toString()]: (state, action) => {
    state.singleUnrecognizedGroup = {
      action: '',
      total: 0,
      examples: [],
      groups: [],
      loading: ApiStatus.ERROR,
      error: action.error
    };
  }
};

const formateExamplesWithActionTitle = (examples, groups = [], actions) => {
  //keeps track of the mapping so we don't have to filter actions{} again for groups[]
  const actionIdToTitle = {};

  //maps action ids to title in the examples array
  const examplesWithTitles = examples.map(ex => {
    const { related_actions } = ex;
    if (related_actions?.length > 0) {
      const actionsWithTitle = [];
      related_actions.forEach(action => {
        const { id } = action;
        const foundAction = _.filter(actions, item => item.id === id);
        if (foundAction.length > 0) {
          actionIdToTitle[id] = foundAction[0].title;
        }
        if (foundAction.length > 0) {
          actionsWithTitle.push({
            id: id,
            name: foundAction[0].title
          });
        }
      });
      return {
        ...ex,
        related_actions: actionsWithTitle
      };
    }
    return ex;
  });

  //maps action ids to title in the groups array
  const groupWithTitles = groups.map(group => {
    const { examples } = group;
    const exampleWithTitle = examples.map(example => {
      const { related_actions } = example;
      if (related_actions?.length > 0) {
        const actionsWithTitle = [];
        related_actions.forEach(action => {
          const { id } = action;
          if (id in actionIdToTitle) {
            actionsWithTitle.push({
              id: id,
              name: actionIdToTitle[id]
            });
          }
        });
        return {
          ...example,
          related_actions: actionsWithTitle
        };
      }
      return example;
    });
    return {
      ...group,
      examples: exampleWithTitle
    };
  });

  return { examplesWithTitles, groupWithTitles };
};
